import React from "react";
import Navbar from "../components/Navbar";
import ContactHero from "../components/contact/ContactHero";

function Contact() {
  return (
    <>
      <Navbar />
      <ContactHero />
    </>
  );
}

export default Contact;